import { Component } from "@angular/core";
import { ProjectTheme } from "src/app/Models/ProjectTheme";

@Component({
    selector: "app-contact",
    templateUrl: "./contact.component.html",
    styleUrl: "./contact.component.scss",
    standalone: false
})
export class ContactComponent {
  /**
   * page image src
   */
  theme: ProjectTheme = "WUnivers";
  /**
   * page image src
   */
  imageSrc: string = "assets/images/WUContact.jpg";
  /**
   * Contact details (the texts around them are under `homePage.contact`)
   */
  text1: string = "info-wiunivers@wissalgroup.com";
  text2: string = `+213 98 230 00 62 - +213 770 61 77 16`;

  /**
   * open the Sétif store on Google Maps
   */
  openLocation() {
    window.open("https://maps.app.goo.gl/CqSpsK3pPHckufZ69", "_blank", "noopener");
  }

  /**
   * contact via email
   */
  sendEmail() {
    window.location.href = "mailto:info-wiunivers@wissalgroup.com";
  }

  /**
   * contact via phone number
   */
  onCallWissal() {
    window.location.href = "tel:+213982300062";
  }
}
